import { RedirectReason } from "@/domain/values/RedirectReason";
import useMyself from "@/features/user/hooks/useMyself";
import { useSignInRequiredAction } from "@/features/user_authentication";
import { getReasonText } from "@/utils/getReasonText";
import { FC, useMemo } from "react";

interface Props {
  userId: number;
  onClick: VoidFunction;
  isFollowing: boolean;
}

const FollowBtn: FC<Props> = ({
  userId,
  isFollowing,
  onClick,
}): JSX.Element => {
  const isMyself = useMyself(userId);
  const { executeAction, SignInModalComponent } = useSignInRequiredAction({
    action: onClick,
    message: getReasonText(RedirectReason.Follow),
  });

  const label = useMemo<string>(() => {
    if (isFollowing) {
      return "フォロー済み";
    } else {
      return "フォロー";
    }
  }, [isFollowing]);

  if (isMyself) return null;

  return (
    <>
      <button onClick={executeAction}>
        <span
          className={[
            "rounded-xs text-center p-8 transition-all text-sm font-bold",
            isFollowing ? "bg-yellow-500 text-primary" : "bg-black text-white",
          ].join(" ")}
        >
          {label}
        </span>
      </button>
      {SignInModalComponent}
    </>
  );
};

export default FollowBtn;
